import { useHistory } from 'react-router-dom';
import React from 'react';

export default function RedirectToHome() {
    const history = useHistory();
    history.push({
        pathname: '/',
    });

    return <React.Fragment />;
}
